import type { ReactNode } from 'react';
import { Hammer } from 'lucide-react';
import { ProTopBar } from '../components/ProTopBar';
import styles from './Dashboard.module.css';

interface Props {
  /** Titolo della funzione (es. "Sessioni live"). */
  title: string;
  /** Una/due frasi su cosa farà la funzione. */
  description: string;
  /** Breadcrumb mono in alto. Default: "Studio Pro · Sport". */
  breadcrumb?: string;
  /** Icona opzionale (lucide). Default: Hammer. */
  icon?: ReactNode;
}

/**
 * Placeholder onesto per funzioni non ancora costruite. Sostituisce il pattern
 * "monta una pagina esistente come segnaposto" (che generava doppioni confondenti
 * in sidebar — vedi /catalogo→Piani e i nav Coach→Workout). Ogni voce di menu deve
 * avere una destinazione DISTINTA: o reale, o un "in arrivo" dedicato.
 */
export default function ComingSoon({ title, description, breadcrumb = 'Studio Pro · Sport', icon }: Props) {
  return (
    <>
      <ProTopBar />

      <div style={{ padding: '4px 0 18px' }}>
        <div
          style={{
            fontFamily: 'var(--mono)',
            fontSize: 10.5,
            fontWeight: 700,
            letterSpacing: 1.6,
            color: 'var(--mute)',
            textTransform: 'uppercase',
          }}
        >
          {breadcrumb}
        </div>
        <h1
          style={{
            fontFamily: 'var(--display)',
            fontWeight: 800,
            fontSize: 32,
            letterSpacing: -1,
            margin: '6px 0 0',
            lineHeight: 1.05,
          }}
        >
          {title}
        </h1>
      </div>

      <section className={styles.card}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            gap: 14,
            padding: '56px 28px',
          }}
        >
          <div
            style={{
              width: 56,
              height: 56,
              borderRadius: 14,
              background: 'var(--surface-2)',
              border: '1px solid var(--line)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'var(--mute)',
            }}
          >
            {icon ?? <Hammer size={26} strokeWidth={1.8} />}
          </div>
          <div
            style={{
              fontFamily: 'var(--mono)',
              fontSize: 10.5,
              fontWeight: 700,
              letterSpacing: 1.4,
              textTransform: 'uppercase',
              color: 'var(--orange-deep, #a87c00)',
            }}
          >
            Funzione in arrivo
          </div>
          <p
            style={{
              maxWidth: 460,
              margin: 0,
              fontSize: 14,
              lineHeight: 1.6,
              color: 'var(--ink-2)',
            }}
          >
            {description}
          </p>
        </div>
      </section>
    </>
  );
}
